// A dev build/run is meaning that we did not build this for production through
// magefile.go, but probably manually or via npm run dev.

const URLCONTAINSSTAGING = window.location.href.includes("staging");
const URLCONTAINSDEV = window.location.href.includes("dev");
const URLCONTAINSNGROK = window.location.href.includes("ngrok");
const unsetVersion = "version: dev-build/run";
export const VERSION = import.meta.env.VITE_VERSION || unsetVersion;
export const VERSION_SET = VERSION !== unsetVersion;
let addoneToUse = "";
if (URLCONTAINSSTAGING) {
  addoneToUse = " (staging)";
} else if (URLCONTAINSDEV) {
  addoneToUse = " (dev)";
} else if (URLCONTAINSNGROK) {
  addoneToUse = " (ngrok)";
}
export const DEV_ADDON = addoneToUse;

export default VERSION;
